import ReactTooltip from 'react-tooltip';

export default function Tooltip({ message }) {
    // console.log({ message });
    return (
        <>
            <span data-tip="React-tooltip" data-for={message} >
                <i className='fi-rr-info fs-7'></i>
            </span>
            <ReactTooltip place="right" id={message} type="light" effect="solid" >
                <span>{message}</span>
            </ReactTooltip>
        </>
    )
}